import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Checkbox,
  Radio,
  FormControlLabel,
  Grid
} from "@mui/material";

interface JumboSelectItem {
  id: string;
  name: string;
  description: string;
}

interface JumboSelectProps {
  items: JumboSelectItem[];
  multiSelect?: boolean;
  selectedItemIds: string[];
  onSelectionChange: (selectedIds: string[]) => void;
}

const JumboSelect: React.FC<JumboSelectProps> = ({
  items,
  multiSelect = false,
  selectedItemIds,
  onSelectionChange,
}) => {
  const isSelected = (id: string) => selectedItemIds.includes(id);

  const handleSelect = (id: string) => {
    let updated: string[] = [];
    if (multiSelect) {
      updated = isSelected(id)
        ? selectedItemIds.filter((sid) => sid !== id)
        : [...selectedItemIds, id];
    } else {
      updated = [id];
    }
    onSelectionChange(updated);
  };

  return (
    <Box width="100%">
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} key={item.id}>
            <Card
              variant="outlined"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                height: 100, // reduce height by half from typical default
              }}
              onClick={() => handleSelect(item.id)}
            >
              <CardContent sx={{ flex: 1, overflow: "hidden" }}>
                <Typography variant="h6" noWrap>{item.name}</Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {item.description}
                </Typography>
              </CardContent>
              <FormControlLabel
                control={
                  multiSelect ? (
                    <Checkbox checked={isSelected(item.id)} />
                  ) : (
                    <Radio checked={isSelected(item.id)} />
                  )
                }
                label=""
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default JumboSelect;
